<div class="global-status">
  <ng-container *ngIf="globalStatus; else noGlobalStatus">
    <h2 class="{{globalStatus.messageStateClass}}">{{globalStatus.messageState}}</h2>
    <app-traffic-light [relay]="globalStatus" (click)="onDisplayRelays()"></app-traffic-light>
  </ng-container>
  <ng-template #noGlobalStatus>
    <h2 i18n class="warning blinking">No data received!</h2>
  </ng-template>
</div>
<audio *ngIf="playStatusSound" preload="auto" [src]="playStatusSound" type="audio/ogg" loop="loop" class="select-player" autoplay="autoplay">
    Audio tag is not supported in your browser
</audio>

<p-dialog i18n-header header="Active RELAY stations" [(visible)]="displayRelays" [style]="{width: '600px', 'max-height': '900px'}">
  <table class="table">
      <thead>
          <tr>
              <th>
                  #
              </th>
              <th>
                  SEMF
              </th>
              <th i18n>Status</th>
              <th i18n>Identifier</th>
          </tr>
      </thead>
      <tbody>
          <tr *ngFor="let relay of relays">
              <th>
                  {{relay.id}}
              </th>
              <td class="traffic-light-specific" [attr.data-relay-id]="relay.id" [attr.data-relay-identifier]="relay.identifier">
                <app-traffic-light [relay]="relay"></app-traffic-light>
              </td>
              <td class="traffic-light-status-specific {{relay.messageStateClass}}" style="opacity: 1;">{{relay.messageState}}</td>
              <td>
                  {{relay.identifier}}
              </td>
          </tr>
      </tbody>
  </table>
</p-dialog>
